import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AlertConfiguresService } from './api/alertConfigures.service';
import { AlertsService } from './api/alerts.service';
import { AssetLocationHistoriesService } from './api/assetLocationHistories.service';
import { AssetLocationsService } from './api/assetLocations.service';
import { AssetsService } from './api/assets.service';
import { AuditLogsService } from './api/auditLogs.service';
import { DeviceHistoriesService } from './api/deviceHistories.service';
import { EmailsService } from './api/emails.service';
import { FloorsService } from './api/floors.service';
import { OrgProfilesService } from './api/orgProfiles.service';
import { RoutersService } from './api/routers.service';
import { TagsService } from './api/tags.service';
import { UserProfilesService } from './api/userProfiles.service';
import { UsersService } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
